// Global variables
const the_win		= jQuery( window );			// The window
const the_doc		= jQuery( document );		// The document
const the_htm		= jQuery( 'html' );			// The html
const the_bod		= jQuery( 'body' );			// The body
const the_html_bod	= jQuery( 'html, body' );	// The html and body
const class_bod		= the_bod.attr( 'class' );	// The body's class

// ----------------------------

let win_width		= window.innerWidth;							// Width value of view port
let curr_root		= document.location.hostname;					// Returns root url
let curr_url    	= window.location.href;							// Current URL
let curr_path    	= window.location.pathname.split( '/' );		// Current path

let has_overlay		= jQuery( '.overlay_window' ).is( ':visible' );	// Has overlay?

// Scroll
let scroll_trigger  = 48; // Scroll trigger
let close_mask		= '';
let watch_list		= false;

// ----------------------------

// Debugging
const _debug        = true;

// ----------------------------

// Advanced search url
let adv_search_url	= 'index.php?main_page=advanced_search_result&keyword=';
let search_autocomplete_timeout = null;

// Fast entry line limit
// TODO: Set as global var via DB
let line_limit = 30;

// Language data object
let lang = {};

// Global for articles
let modal_articles = [];

// ----------------------------

// Mask
if ( has_overlay ) {
    close_mask = 'mask_layer( true )';
} else {
    close_mask = 'mask_layer( false )';
}

// ----------------------------

let mouse_timer     = 0;
let function_timer  = 0;

// ----------------------------

let webbrowser = navigator.userAgent.toLowerCase();

// ----------------------------

// Debug
// console.log( 'pathname: ' + pathname + '\n' );
// console.log( 'url: ' + url + '\n' );
// console.log( 'root: ' + root + '\n' );

// Show jQuery version
// if ( typeof jQuery !== 'undefined' ) {
//     // jQuery is loaded => print the version
//     console.log( jQuery.fn.jquery );
// }